import Markdown from 'react-markdown';

import type { ChatMessageProps } from '../types';
import { ChatMessage } from './ChatMessage';

export function UserMessage<MetadataType>({ timestamp, role, content }: ChatMessageProps<'user', MetadataType>) {
  return <ChatMessage content={<Markdown>{content}</Markdown>} role={role} timestamp={timestamp} />;
}
